import { render, staticRenderFns } from "./EditOptionLoader.vue?vue&type=template&id=6f036f94"
import script from "./EditOptionLoader.vue?vue&type=script&lang=ts"
export * from "./EditOptionLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports